import script from "./EditRankFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRankFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditRankFormComponent.vue?vue&type=style&index=0&id=bea9b346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bea9b346"]])

export default __exports__